import { api } from '../api';
import { VerificationResponse } from '../types/verificationResponse';

export async function getDomainVerification(
  projectId: string,
): Promise<VerificationResponse> {
  const response = await api.get(`admin/projects/${projectId}/domain/verify`);
  return response.json();
}
